import { z } from "zod";

export const CHAT_START_FAILURE_EVENT = "chat_start_failed" as const;

export const chatStartFailureSchema = z
    .object({
        failure_site: z.enum(["create_conversation", "hydration_retry"]),
        conversation_id_present: z.boolean(),
        error_name: z.string().min(1).max(80),
        error_message: z.string().min(1).max(200),
        error_status: z
            .union([z.number().int(), z.string().min(1).max(20)])
            .optional(),
    })
    .strict();

export type ChatStartFailure = z.infer<typeof chatStartFailureSchema>;

const rawErrorStatusSchema = z.preprocess(
    (value) => ({
        present: value != null,
        value:
            typeof value === "number" && Number.isInteger(value)
                ? value
                : typeof value === "string" && value.length > 0
                  ? value.slice(0, 20)
                  : undefined,
    }),
    z.object({
        present: z.boolean(),
        value: z.union([z.number().int(), z.string()]).optional(),
    }),
);
const rawChatErrorSchema = z
    .object({
        message: z
            .string()
            .min(1)
            .transform((value) => value.slice(0, 200))
            .optional()
            .catch(undefined),
        name: z
            .string()
            .min(1)
            .transform((value) => value.slice(0, 80))
            .optional()
            .catch(undefined),
        response: z
            .object({ status: rawErrorStatusSchema.optional() })
            .optional()
            .catch(undefined),
        status: rawErrorStatusSchema.optional(),
    })
    .catch({});
export const chatStartFailureInputSchema = z.object({
    failure_site: z.enum(["create_conversation", "hydration_retry"]),
    conversation_id_present: z.boolean(),
    error: z.preprocess((value) => value, rawChatErrorSchema),
});
export type ChatStartFailureInput = z.input<typeof chatStartFailureInputSchema>;
